import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage, Lang } from '../lib/i18n';
const LANGUAGES: {
  code: Lang;
  flag: string;
}[] = [{
  code: 'en',
  flag: '🇬🇧'
}, {
  code: 'hr',
  flag: '🇭🇷'
}];
export function LanguageToggle() {
  const {
    lang,
    setLang
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const currentFlag = LANGUAGES.find(l => l.code === lang)?.flag;
  const otherLanguages = LANGUAGES.filter(l => l.code !== lang);
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 4.5,
    ease: [0.16, 1, 0.3, 1]
  }} className="fixed top-6 right-6 md:top-8 md:right-12 lg:right-20 z-50" data-id="element-240">
      <button onClick={() => setIsOpen(!isOpen)} className="w-9 h-9 rounded-full border border-border bg-background/80 backdrop-blur-sm flex items-center justify-center hover:border-secondary/40 hover:bg-white/[0.03] transition-all duration-300" title={lang === 'en' ? 'Promijeni jezik' : 'Change language'} data-id="element-241">
        <span className="text-base leading-none" data-id="element-242">{currentFlag}</span>
      </button>

      <AnimatePresence data-id="element-243">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -4,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -4,
        scale: 0.95
      }} transition={{
        duration: 0.15,
        ease: [0.16, 1, 0.3, 1]
      }} className="absolute top-full right-0 mt-1.5" data-id="element-244">
            {otherLanguages.map(l => <button key={l.code} onClick={() => {
          setLang(l.code);
          setIsOpen(false);
        }} className="w-9 h-9 rounded-full border border-border bg-background/90 backdrop-blur-sm flex items-center justify-center hover:border-secondary/40 hover:bg-white/[0.06] transition-all duration-300" title={l.code === 'hr' ? 'Hrvatski' : 'English'} data-id="element-245">
                <span className="text-base leading-none" data-id="element-246">{l.flag}</span>
              </button>)}
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}